import styled from 'styled-components'
import theme, {colors} from '../../../../styles/theme'

export const ReportLinkBox = styled.span`
  font-size: 12px;
  color: ${colors.blue1};
  margin-left: auto;
  cursor: pointer;
`

export const CardText = styled.p`
  margin: 0;
  padding: 0;
  font-size: 14px;
  line-height: 20px;
  color: ${colors.bksGray70};
  font-weight: 700;

  && span {
    font-size: 12px;
    color: ${colors.bksGray70};
    font-weight: 400;
  }
`

export const CardContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const IconBox = styled.div`
  display: flex;
  flex-flow: column;
  gap: 4px;
  font-size: 12px;
  color: ${colors.bksGray70};
  align-items: center;
  cursor: pointer;
`

export const DaysBox = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  @media only screen and (max-width: 1130px) {
    flex-flow: column;
    align-items: flex-start;
    gap: 0px;
  }

  ${theme.breakpoints.down('md')} {
    flex-flow: wrap;
    gap: 8px;
    align-items: center;
  }
`

export const StatusBox = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`

export const RiskText = styled.span`
  color: ${colors.crimsonRed} !important;
`

export const BehindText = styled.span`
  color: ${colors.orange} !important;
`

export const TrackText = styled.span`
  color: ${colors.pa} !important;
`

export const AheadText = styled.span`
  color: ${colors.indiaGreen} !important;
`
